import React, { useState } from 'react';
import { Modal, Input, Button, Row, Col } from 'antd';
import { ArrowLeftOutlined, ArrowRightOutlined, RocketFilled, RocketOutlined, RocketTwoTone } from '@ant-design/icons';
import styled from 'styled-components';
import HTTPClient from "../../utils/HTTPClient";
import { useTranslation } from 'react-i18next';

const StyledModal = styled(Modal)`
  .ant-modal-content {
    border-radius: 27px;
    overflow: hidden;
  }
  
  .ant-modal-body {
    padding: 0;
  }
`;

const ModalHeader = styled.div`
  display: flex;
  align-items: center;
`;

const IconPlaceholder = styled.div`
  width: 40px;
  height: 40px;
  background-color: #d9d9d9;
  border-radius: 50%;
  margin-right: 15px;
`;

const HeaderText = styled.div`
  h2 {
    margin: 0;
    font-size: 18px;
  }
  p {
    margin: 5px 0 0;
    font-size: 14px;
    color: #666;
  }
`;

const ModalBody = styled.div`
  padding: 20px;
`;

const StepIndicator = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 20px;
`;

const Step = styled.div`
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: ${props => props.active ? '#1890ff' : '#d9d9d9'};
  margin: 0 10px;
`;

const StepContent = styled.div`
  margin-bottom: 20px;
  h3 {
    margin-bottom: 10px;
  }
`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 20px;
`;

const StyledButton = styled(Button)`
  border-radius: 20px;
  margin: 0 10px;
`;

const WelcomeModal = ({ open, onClose, fetch }) => {
  const [currentStep, setCurrentStep] = useState(0);
  const [loadingGeneration, setLoadingGeneration] = useState(false);
  const { t } = useTranslation();
  const [formData, setFormData] = useState({
    name: "",
    sector: "",
    business_description: ""
  });

  const steps = [
    { title: t("ab_home.welcome_modal.step1"), field: "name", label: "Appbox.cloud" },
    { title: t("ab_home.welcome_modal.step2"), field: "sector", label: "Digital Marketing" },
    { title: t("ab_home.welcome_modal.step3"), field: "business_description", label: "", textarea: true },
  ];

  const handleInputChange = (field, value) => {
    setFormData(prevData => ({
      ...prevData,
      [field]: value
    }));
  };

  const handleNext = () => {
    if (currentStep < steps.length - 1) {
      setCurrentStep(currentStep + 1);
    }
  };

  const handlePrev = () => {
    if (currentStep > 0) {
      setCurrentStep(currentStep - 1);
    }
  };

  const makeWebsite = () => {
    setLoadingGeneration(true);
    HTTPClient.post("/ab_home/project_info", { name: formData.name, sector: formData.sector, business_description: formData.business_description }).then((res) => {
      HTTPClient.post("/ab_website/generate_website").then((res) => {
        const website_url = res.data
        window.open(website_url);
        setLoadingGeneration(false);
        fetch();
      }).catch((err) => {
        console.log(err);
        setLoadingGeneration(false);
      });
    }).catch((err) => {
      console.log(err);
      setLoadingGeneration(false);
    });
  };

  const isNextDisabled = () => {
    const currentField = steps[currentStep].field;
    return formData[currentField].trim() === '';
  };

  return (
    <StyledModal
      open={open}
      onCancel={onClose}
      footer={null}
      width={500}
      closeIcon={null}
      title={<div style={{ fontSize: "24px" }}><RocketOutlined rotate={45} style={{ color: "#5F4DEE", fontSize: "28px", marginRight: "10px" }} />{t("ab_home.welcome_modal.title")}</div>}
    >
      <ModalHeader>
        <Row>
          <p>{t("ab_home.welcome_modal.text")}{" "}<b>{t("ab_home.welcome_modal.text2")}</b></p>
        </Row>
      </ModalHeader>
      <ModalBody>
        <StepIndicator>
          {steps.map((_, index) => (
            <Step key={index} active={index <= currentStep} />
          ))}
        </StepIndicator>
        <StepContent>
          <h3>{steps[currentStep].title}</h3>
          {steps[currentStep].textarea ? (
            <Input.TextArea
              rows={4}
              placeholder={steps[currentStep].label}
              value={formData[steps[currentStep].field]}
              onChange={(e) => handleInputChange(steps[currentStep].field, e.target.value)}
            />
          ) : (
            <Input
              placeholder={steps[currentStep].label}
              value={formData[steps[currentStep].field]}
              onChange={(e) => handleInputChange(steps[currentStep].field, e.target.value)}
            />
          )}
        </StepContent>
        <ButtonContainer>
          {currentStep > 0 && (
            <StyledButton
              onClick={handlePrev}
              disabled={currentStep === 0}
              icon={<ArrowLeftOutlined />}
              loading={loadingGeneration}
            >
              Previous
            </StyledButton>
          )}
          <StyledButton
            type="primary"
            onClick={currentStep === steps.length - 1 ? makeWebsite : handleNext}
            icon={<ArrowRightOutlined />}
            disabled={isNextDisabled()}
            loading={loadingGeneration}
          >
            {currentStep === steps.length - 1 ? t("ab_home.welcome_tour.make_site") : 'Next'}
          </StyledButton>
        </ButtonContainer>
      </ModalBody>
    </StyledModal>
  );
};

export { WelcomeModal };